/**
 * DevExtreme (esm/__internal/grids/new/grid_core/core/events/native_event_listener.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export class NativeEventListener {
    constructor() {
        this.unsubscribeArray = []
    }
    add(elementRef, eventName, eventHandler) {
        var _elementRef$current;
        null === (_elementRef$current = elementRef.current) || void 0 === _elementRef$current || _elementRef$current.addEventListener(eventName, eventHandler);
        this.unsubscribeArray.push((() => {
            var _elementRef$current2;
            null === (_elementRef$current2 = elementRef.current) || void 0 === _elementRef$current2 || _elementRef$current2.removeEventListener(eventName, eventHandler)
        }));
        return this
    }
    unsubscribe() {
        this.unsubscribeArray.forEach((fn => fn()))
    }
}
